import { useNavigate, useLocation } from 'react-router-dom'
import { getAuth } from '../modules/auth'
import { useEffect, useState } from 'react'
import { setTestScoreStrategyModal } from '../components/Auth/setPrompts'
import { AuthReactGAHandlers } from '../components/ReactGAHandlers'
import { pageRoutes, updateTitleAndDescription } from '../components/dictionary'
import { ValidateEmailModal } from '../components/Auth/ValidateEmailModal'
import { Modal } from 'bootstrap'
import { ExplorerBlock } from '../components/Home/ExplorerBlock'
import { Hero } from '../components/Home/Hero'
import { AboutUs } from '../components/Home/AboutUs'
import { Showcase } from '../components/Home/Showcase'
import { FAQ } from '../components/Home/FAQ'
import { Testimonials } from '../components/Home/Testimonials'
import { StickyNavbar } from '../components/Marketing/StickyNavbar'
import { HomepageReactGAHandlers } from '../components/ReactGAHandlers'
import { Fragment } from 'react'

// image imports
import CollegeExplorer from '../../custom_assets/home/college_explorer/college_explorer.jpg'
import collegeExplorerPoint1 from '../../custom_assets/home/college_explorer/point_1.png'
import collegeExplorerPoint1Mobile from '../../custom_assets/home/college_explorer/point_1_mobile.png'
import collegeExplorerPoint2 from '../../custom_assets/home/college_explorer/point_2.png'
import collegeExplorerPoint2Mobile from '../../custom_assets/home/college_explorer/point_2_mobile.png'
import collegeExplorerPoint3 from '../../custom_assets/home/college_explorer/point_3.png'
import collegeExplorerPoint3Mobile from '../../custom_assets/home/college_explorer/point_3_mobile.png'

import MajorExplorer from '../../custom_assets/home/major_explorer/major_explorer.jpg'
import majorExplorerPoint1 from '../../custom_assets/home/major_explorer/point_1.png'
import majorExplorerPoint1Mobile from '../../custom_assets/home/major_explorer/point_1_mobile.png'
import majorExplorerPoint2 from '../../custom_assets/home/major_explorer/point_2.png'
import majorExplorerPoint2Mobile from '../../custom_assets/home/major_explorer/point_2_mobile.png'
import majorExplorerPoint3 from '../../custom_assets/home/major_explorer/point_3.png'
import majorExplorerPoint3Mobile from '../../custom_assets/home/major_explorer/point_3_mobile.png'

import ExtracurricularsExplorer from '../../custom_assets/home/ec_explorer/extracurriculars_explorer.jpg'
import ecExplorerPoint1 from '../../custom_assets/home/ec_explorer/point_1.png'
import ecExplorerPoint1Mobile from '../../custom_assets/home/ec_explorer/point_1_mobile.png'
import ecExplorerPoint2 from '../../custom_assets/home/ec_explorer/point_2.png'
import ecExplorerPoint2Mobile from '../../custom_assets/home/ec_explorer/point_2_mobile.png'
import ecExplorerPoint3 from '../../custom_assets/home/ec_explorer/point_3.png'
import ecExplorerPoint3Mobile from '../../custom_assets/home/ec_explorer/point_3_mobile.png'

import collegeIcon from '../../custom_assets/dashboard/college_list.png'
import extracurricularsIcon from '../../custom_assets/dashboard/ec.png'
import majorsIcon from '../../custom_assets/dashboard/intended_major.png'

import { CTA } from '../components/Home/CTA'


const Home = ({ setPrompt, setNavigateTo, currentUser, setCurrentUser }) => {

  let apiToken: any = undefined
  let navigate = useNavigate()

  if (getAuth()?.api_token && getAuth()?.groups) {
    apiToken = getAuth()?.api_token
  }

  const location = useLocation()

  const { handleGAEventSignInModalOpen } = AuthReactGAHandlers()
  const { handleHomepageClick } = HomepageReactGAHandlers()

  // const [testimonialIndex, setTestimonialIndex] = useState(0)
  const [validateEmailTrigger, setValidateEmailTrigger] = useState(false)
  const [validationComplete, setValidationComplete] = useState(false)
  const [emailAddress, setEmailAddress] = useState<any>(null)

  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

  useEffect(() => {
    const updateScreenSize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', updateScreenSize);
    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  // const headline = (
  //   <div className='dca-home-headline-container'>
  //     <img
  //       src={Headline} alt='headline'
  //       className='dca-headline-img'>
  //     </img>
  //     <div className='dca-home-header-wrapper'>
  //       <span className='dca-home-header-1'>Get an edge in your college admissions journey</span>
  //       <span className='dca-home-header-2'>Cutting-edge tools and insights to improve your chances of getting in to the most selective schools
  //       </span>
  //     </div>
  //   </div>
  // )

  // const returnLeftImageComponent = (data, positionA = '50%', positionB = '80%', scale = 1.0) => {
  //   return (
  //     <div className="dca-home-component-wrapper-L">

  //       <div className='dca-home-img-wrapper-L'>
  //         <img
  //           src={data.imageSrc}
  //           alt={data.altImageText}
  //           className='dca-home-img'
  //           style={{
  //             '--position-a': positionA,
  //             '--position-b': positionB,
  //             '--scale': scale,
  //           } as any}
  //         ></img>
  //       </div>

  //       <div className='dca-cta-text-wrapper-L'>
  //         <div style={{ lineHeight: '1.6em' }}>
  //           <div>{data.text}</div>
  //           <button
  //             onClick={() => navigate(data.navigateURL)}
  //             className='dca-home-cta-button'
  //           >{data.buttonText}
  //             <i
  //               className="ms-2 fa-solid fa-arrow-right"
  //               style={{
  //                 color: 'black',
  //                 fontWeight: 'bold',
  //                 paddingLeft: '5px',
  //                 fontSize: '1.2rem'
  //               }}></i></button>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }

  // const returnRightImageComponent = (data) => {

  //   return (
  //     <div className="dca-home-component-wrapper-R">
  //       <div className='dca-cta-text-wrapper-R'>
  //         <div style={{ lineHeight: '1.6em' }}>
  //           {data.text}
  //         </div>
  //         <div>
  //           <button
  //             onClick={() => navigate(data.navigateURL)}
  //             className='dca-home-cta-button'
  //           >
  //             {data.buttonText}
  //             <i className="ms-2 fa-solid fa-arrow-right" style={{
  //               color: 'black',
  //               fontWeight: 'bold',
  //               paddingLeft: '5px',
  //               fontSize: '1.2rem'
  //             }}></i>
  //           </button>
  //         </div>
  //       </div>

  //       <div className='dca-home-img-wrapper-R'>
  //         <img
  //           src={data.imageSrc}
  //           alt={data.altImageText}
  //           className='dca-home-img'
  //         />
  //       </div>
  //     </div>
  //   )
  // }

  // const noAuthTestScoreCTA = (data, positionA = '50%', positionB = '80%', scale = 1.0) => {
  //   return (<div className="dca-home-component-wrapper-L">

  //     <div className='dca-home-img-wrapper-L'>
  //       <img
  //         src={data.imageSrc}
  //         alt={data.altImageText}
  //         className='dca-home-img'
  //         style={{
  //           '--position-a': positionA,
  //           '--position-b': positionB,
  //           '--scale': scale,
  //         } as any}></img></div>

  //     <div className='dca-cta-text-wrapper-L'>
  //       <div style={{ lineHeight: '1.6em' }}>
  //         <div>{data.text}</div>

  //         <a
  //           data-bs-toggle="modal"
  //           href="#login_modal"
  //           onClick={() => {
  //             setTestScoreStrategyModal(apiToken, navigate, setPrompt, setNavigateTo);
  //             handleGAEventSignInModalOpen('forced')
  //           }}
  //           style={{ color: 'black' }}
  //           className='dca-home-noauth-testscore-cta-button'
  //         >{data.buttonText}
  //           <i
  //             className="ms-2 fa-solid fa-arrow-right"
  //             style={{
  //               color: 'black',
  //               fontWeight: 'bold',
  //               paddingLeft: '5px',
  //               fontSize: '1.2rem'
  //             }}></i>
  //         </a>
  //       </div>

  //     </div>
  //   </div>
  //   )
  // }

  // const returnTestScoreStrategyCTA = (apiToken) => {

  //   switch (true) {
  //     case apiToken !== undefined:
  //       return returnLeftImageComponent({ imageSrc: TestScore, altImageText: 'test-score', text: 'Get personalized recommendations for navigating the evolving test-optional landscape', navigateURL: pageRoutes.testScoreStrategy, buttonText: 'Advice On Test Scores' }, '50%', '60%')
  //     default:
  //       return noAuthTestScoreCTA({ imageSrc: TestScore, altImageText: 'test-score', text: 'Get personalized recommendations for navigating the evolving test-optional landscape', navigateURL: pageRoutes.testScoreStrategy, buttonText: 'Advice On Test Scores' }, '50%', '60%')
  //   }

  // }

  // const collegeCTA = (
  //   <div className="dca-home-component-wrapper-R">

  //     <div className='dca-cta-text-wrapper-R'>
  //       <div style={{ lineHeight: '1.6em' }}>
  //         Deep dive on the most selective U.S. colleges to identify the right schools and majors for your profile and interests
  //       </div>

  //       <div>
  //         <button
  //           onClick={() => navigate(pageRoutes.collegeSearch)}
  //           className='dca-home-cta-button'
  //         >Build A College List<i className="ms-2 fa-solid fa-arrow-right" style={{
  //           color: 'black',
  //           fontWeight: 'bold',
  //           paddingLeft: '5px',
  //           fontSize: '1.2rem'
  //         }}></i>
  //         </button>

  //         <button
  //           onClick={() => navigate(pageRoutes.majorSearch)}
  //           className='dca-home-cta-button'>Explore Potential Majors<i className="ms-2 fa-solid fa-arrow-right" style={{
  //             color: 'black',
  //             fontWeight: 'bold',
  //             paddingLeft: '5px',
  //             fontSize: '1.2rem'
  //           }}></i></button>
  //       </div>

  //     </div>

  //     <div className='dca-home-img-wrapper-R'>
  //       <img
  //         src={College}
  //         alt='college'
  //         className='dca-home-img'
  //       ></img>
  //     </div>
  //   </div>
  // )

  // const advisorsCTA = (
  //   <div className="dca-home-component-wrapper-L">

  //     <div className='dca-home-img-wrapper-L'>
  //       <img
  //         src={Advisors}
  //         alt={'advisors'}
  //         className='dca-home-img'
  //         style={{
  //           '--position-a': '50%',
  //           '--position-b': '80%',
  //           '--scale': 1.0,
  //         } as any}></img></div>

  //     <div className='dca-cta-text-wrapper-L'>
  //       <div style={{ lineHeight: '1.6em' }}>
  //         <div>Connect with college students to get an insider perspective on colleges, majors and extracurricular activities of interest</div>
  //         {/* <button
  //           disabled
  //           className='dca-home-cta-button'
  //           style={{ background: '#BFEFFE' }}
  //         >Coming Soon!
  //         </button> */}
  //         <button
  //           onClick={() => navigate(pageRoutes.advisorSearch)}
  //           className='dca-home-cta-button'>Meet Insiders<i className="ms-2 fa-solid fa-arrow-right" style={{
  //             color: 'black',
  //             fontWeight: 'bold',
  //             paddingLeft: '5px',
  //             fontSize: '1.2rem'
  //           }}></i></button>
  //       </div>
  //     </div>

  //   </div>
  // )

  // const returnTestimonial = (name, role, text) => {
  //   return (
  //     <div className='d-flex flex-column align-items-center' style={{ width: '40%', padding: '10px' }}>
  //       <div className='dca-testimonial-text'>{text}</div>
  //       <div className='dca-testimonial-name' style={{ marginTop: '30px' }}>
  //         <span>{name},</span>
  //         <span>{role}</span>
  //       </div>
  //     </div>
  //   )
  // }

  // const returnTestimonialMobile = (name, role, text) => {
  //   return (
  //     <div className='d-flex flex-column align-items-center' style={{ width: '80%', padding: '10px' }}>
  //       <div className='dca-testimonial-text'>{text}</div>
  //       <div className='dca-testimonial-name' style={{ marginTop: '30px' }}>
  //         <span>{name},</span>
  //         <span>{role}</span>
  //       </div>
  //     </div>
  //   )
  // }

  // const testimonials = (
  //   <div style={{ marginTop: '15vh' }}>
  //     {/* Row 1 */}
  //     <div className='dca-testimonial-container'>
  //       {returnTestimonial('Liana', 'Columbia University student', '“I love how data-driven the site is with so many insightful tools and cool visualizations. NextFour should be the definitive starting point for all high school students applying to the top colleges!”')}
  //       {returnTestimonial('Jonathan', 'Stanford University student', '“NextFour is truly amazing! I would have absolutely loved to have something like this when I applied, especially to help with extracurriculars to strengthen my applications.” ')}
  //     </div>

  //     {/* Row 2 */}
  //     <div className='dca-testimonial-container'>
  //       {returnTestimonial('Laasya', 'high school student', `“I've tried several alternative solutions before, but nothing compares to your service. Highly recommended!”`)}
  //       {returnTestimonial('Enerel', 'high school student', '“Very nicely curated set of resources for aspring college applicants, all consolidated into one easy-to-use product.”')}
  //     </div>

  //     {/* Row 3 */}
  //     <div className='dca-testimonial-container'>
  //       {returnTestimonial('Alex', 'parent', '“We know firsthand just how important it is to be strategic throughout the college application process - from picking majors, selecting EC activites, building a college list, etc. NextFour will be immensely helpful to families as they navigate all those critical decisions through high school.”')}
  //       {returnTestimonial('Manoj', 'parent', '“NextFour is like a breath of fresh air, bringing some much-needed technology and innovation to the world of college admissions. I have spent countless hours and thousands of dollars on college counseling for our son, but have already learned far more from NextFour!” ')}
  //     </div>
  //   </div>
  // )

  // const testimonialsMobile = (
  //   <div className='d-flex flex-column justify-content-center' style={{ marginTop: '5vh', width: '100%' }}>
  //     <div className='dca-testimonial-container'>
  //       {returnTestimonialMobile('Liana', 'Columbia University student', '“I love how data-driven the site is with so many insightful tools and cool visualizations. NextFour should be the definitive starting point for all high school students applying to the top colleges!”')}
  //     </div>

  //     <div className='dca-testimonial-container'>
  //       {returnTestimonialMobile('Jonathan', 'Stanford University student', '“NextFour is truly amazing! I would have absolutely loved to have something like this when I applied, especially to help with extracurriculars to strengthen my applications.” ')}
  //     </div>

  //     <div className='dca-testimonial-container'>
  //       {returnTestimonialMobile('Laasya', 'high school student', `“I've tried several alternative solutions before, but nothing compares to your service. Highly recommended!”`)}
  //     </div>

  //     <div className='dca-testimonial-container'>
  //       {returnTestimonialMobile('Enerel', 'high school student', '“Very nicely curated set of resources for aspring college applicants, all consolidated into one easy-to-use product.”')}
  //     </div>

  //     <div className='dca-testimonial-container'>
  //       {returnTestimonialMobile('Alex', 'parent', '“We know firsthand just how important it is to be strategic throughout the college application process - from picking majors, selecting EC activites, building a college list, etc. NextFour will be immensely helpful to families as they navigate all those critical decisions through high school.”')}
  //     </div>

  //     <div className='dca-testimonial-container'>
  //       {returnTestimonialMobile('Manoj', 'parent', '“NextFour is like a breath of fresh air, bringing some much-needed technology and innovation to the world of college admissions. I have spent countless hours and thousands of dollars on college counseling for our son, but have already learned far more from NextFour!” ')}
  //     </div>
  //   </div>
  // )

  useEffect(() => {

    updateTitleAndDescription()

    const params = new URLSearchParams(location.search);
    let modalIdParam = params.get('modal')
    let emailAddressParam = params.get('email')

    modalIdParam === 'validateEmail' && setValidateEmailTrigger(true)
    emailAddressParam && setEmailAddress(emailAddressParam)

  }, [])

  useEffect(() => {

    const modalElement: any = document.getElementById('validate_email_modal');
    const validateEmailModal = new Modal(modalElement);

    // For testing, show modal on load--
    // validateEmailModal.show()

    if (validateEmailTrigger) {
      validateEmailModal.show()
    }

    else {
      validateEmailModal.hide();
      const removeModalBackdrop = (modalElement) => {
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop && !document.body.contains(modalElement)) {
          backdrop.remove();
        }
      };
      removeModalBackdrop(modalElement);
    }

  }, [validateEmailTrigger]);

  useEffect(() => {
    if (validationComplete) {
      window.history.replaceState({}, '', `${pageRoutes.home}`)
    }
  }, [validationComplete])

  let collegeContentArray = [
    {
      activePoint: 0,
      group: 'college',
      span1: 'Understand admission dynamics at the top 100 colleges to confidently assess your fit and develop a balanced college list',
      activeSpan: undefined,
      image: window.innerWidth <= 768 ? collegeExplorerPoint1 : collegeExplorerPoint1,
    },
    {
      activePoint: 1,
      group: 'college',
      span1: 'Leverage our proprietary rankings to determine the optimal colleges for your individual interests',
      activeSpan: undefined,
      image: collegeExplorerPoint2,
    },
    {
      activePoint: 2,
      group: 'college',
      span1: 'Get an edge by connecting with students who got into your dream schools and learning from their experiences',
      activeSpan: undefined,
      image: collegeExplorerPoint3
    }
  ]

  let collegeContentArrayMobile = [
    {
      activePoint: 0,
      group: 'college',
      span1: 'Understand admission dynamics at the top 100 colleges to confidently assess your fit and develop a balanced college list',
      activeSpan: undefined,
      image: collegeExplorerPoint1Mobile,
    },
    {
      activePoint: 1,
      group: 'college',
      span1: 'Leverage our proprietary rankings to determine the optimal colleges for your individual interests',
      activeSpan: undefined,
      image: collegeExplorerPoint2Mobile,
    },
    {
      activePoint: 2,
      group: 'college',
      span1: 'Get an edge by connecting with students who got into your dream schools and learning from their experiences',
      activeSpan: undefined,
      image: collegeExplorerPoint3Mobile
    }
  ]

  let ecContentArray = [
    {
      activePoint: 0,
      group: 'ec',
      span1: 'Search the largest database of summer programs, internships, etc. to develop your passions and strengthen your EC profile',
      activeSpan: undefined,
      image: ecExplorerPoint1,
    },
    {
      activePoint: 1,
      group: 'ec',
      span1: 'Pursue ECs strategically by referencing our exclusive analytics on their college admissions impact',
      activeSpan: undefined,
      image: ecExplorerPoint2
    },
    {
      activePoint: 2,
      group: 'ec',
      span1: 'Get an edge for competitive opportunities via mentorship from students with directly relevant experience',
      activeSpan: undefined,
      image: ecExplorerPoint3
    }
  ]

  let ecContentArrayMobile = [
    {
      activePoint: 0,
      group: 'ec',
      span1: 'Search the largest database of summer programs, internships, etc. to develop your passions and strengthen your EC profile',
      activeSpan: undefined,
      image: ecExplorerPoint1Mobile,
    },
    {
      activePoint: 1,
      group: 'ec',
      span1: 'Pursue ECs strategically by referencing our exclusive analytics on their college admissions impact',
      activeSpan: undefined,
      image: ecExplorerPoint2Mobile
    },
    {
      activePoint: 2,
      group: 'ec',
      span1: 'Get an edge for competitive opportunities via mentorship from students with directly relevant experience',
      activeSpan: undefined,
      image: ecExplorerPoint3Mobile
    }
  ]

  let majorContentArray = [
    {
      activePoint: 0,
      group: 'major',
      span1: 'Explore majors effortlessly with our exclusive metasearch—offering comprehensive access to key program details by college',
      activeSpan: undefined,
      image: majorExplorerPoint1,
    },
    {
      activePoint: 1,
      group: 'major',
      span1: 'Discover adjacent majors to find the best fit at target schools and optimize application strategy',
      activeSpan: undefined,
      image: majorExplorerPoint2
    },
    {
      activePoint: 2,
      group: 'major',
      span1: 'Get insider perspective on prospective majors by consulting with college students majoring in those fields',
      activeSpan: undefined,
      image: majorExplorerPoint3
    }
  ]

  let majorContentArrayMobile = [
    {
      activePoint: 0,
      group: 'major',
      span1: 'Explore majors effortlessly with our exclusive metasearch—offering comprehensive access to key program details by college',
      activeSpan: undefined,
      image: majorExplorerPoint1Mobile,
    },
    {
      activePoint: 1,
      group: 'major',
      span1: 'Discover adjacent majors to find the best fit at target schools and optimize application strategy',
      activeSpan: undefined,
      image: majorExplorerPoint2Mobile
    },
    {
      activePoint: 2,
      group: 'major',
      span1: 'Get insider perspective on prospective majors by consulting with college students majoring in those fields',
      activeSpan: undefined,
      image: majorExplorerPoint3Mobile
    }
  ]

  const getStartedStickyNav =
    // <button
    //   className="dca-home-hero-cta-button"
    //   style={{ minWidth: currentUser?.dashboardAlertShown == true ? 'fit-content' : '' }}
    //   // id="dca-home-stickyNav-button"
    //   onClick={() => {
    //     handleHomepageClick('CTA Header');
    //     navigate(pageRoutes.dashboard)
    //   }}>{currentUser?.dashboardAlertShown == true ? <span
    //     // className="d-flex flex-row justify-content-center align-items-center"
    //     className="dca-home-hero-cta-button-text"
    //     style={{ whiteSpace: 'nowrap' }}>My Dashboard <i
    //       className="fa-solid fa-arrow-right"
    //       style={{
    //         color: 'black',
    //         fontWeight: 'bold',
    //         paddingLeft: '5px',
    //         fontSize: '1.2rem'
    //       }}></i></span> : <span
    //         className="dca-home-hero-cta-button-text">Get Started</span>}
    // </button>

    // 1307
    <button
      className="dca-marketing-access-duration-purchase-button-nav"
      style={{ marginRight: '22px' }}
      onClick={() => {
        handleHomepageClick('CTA Header');
        navigate(pageRoutes.dashboard)
      }}
    ><span className="dca-marketing-access-duration-purchase-button-nav-text" style={{ whiteSpace: 'nowrap' }}>{currentUser?.dashboardAlertShown == true ? <span
    >My Dashboard <i
      className="fa-solid fa-arrow-right"
      style={{
        color: 'black',
        fontWeight: 'bold',
        paddingLeft: '5px',
        fontSize: '1.2rem'
      }}></i></span> : 'Get Started'}</span>
    </button>

  return (
    <div className='dca-home'>

      <StickyNavbar purchaseButton={getStartedStickyNav} home={true} />

      <ValidateEmailModal
        emailAddress={emailAddress}
        validationComplete={validationComplete}
        setValidationComplete={setValidationComplete}
        validateEmailTrigger={validateEmailTrigger}
        setValidateEmailTrigger={setValidateEmailTrigger}
        setCurrentUser={setCurrentUser} />

      <Hero user={currentUser} isMobile={isMobile} />

      <AboutUs />

      <ExplorerBlock backgroundImage={CollegeExplorer} title={'Optimize your college choices'} contentArray={collegeContentArray} link={{ navigate: pageRoutes.collegeSearch, text: 'College Explorer', icon: collegeIcon, className: 'college' }} mobileContentArray={collegeContentArrayMobile} backgroundPosition={'right'} GAHandlerGroup={'College'} />

      <ExplorerBlock backgroundImage={ExtracurricularsExplorer} title={'Discover needle-moving extracurriculars'} contentArray={ecContentArray} link={{ navigate: pageRoutes.ecSearch, text: 'Extracurriculars Explorer', icon: extracurricularsIcon, className: 'ec' }} mobileContentArray={ecContentArrayMobile} backgroundPosition={'right'} GAHandlerGroup={'EC'} />

      <ExplorerBlock backgroundImage={MajorExplorer} title={'Pinpoint the perfect majors'} contentArray={majorContentArray} link={{ navigate: pageRoutes.majorSearch, text: 'Majors Explorer', icon: majorsIcon, className: 'major' }} mobileContentArray={majorContentArrayMobile} backgroundPosition={'top'} GAHandlerGroup={'Major'} />

      <Showcase />

      <FAQ />

      <Testimonials />

      <CTA user={currentUser} />

    </div>
  )

}

export { Home }